import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Images } from "../Components/Images";
import ScheduleModal from "./ScheduleModal";
import {
  CURRENT_CHAIN_ID,
  UseSchedulePay,
  UseTriggerArbitrage,
  UseTriggerArbitragePoly,
  toFixedNumber,
} from "../Hooks/useWeb3";
import { toast } from "react-hot-toast";
import { getAccount } from "../Hooks/useAccount";
import { AddSchedule, GetPlanInfo } from "../actions/markets";
import { AddTransaction } from "../actions/markets";
import { userPlanDetail } from "../Hooks/UseContract";
import { getPlanData } from "../actions/user";

const PairModal = ({ show, handleShow, handleClose, data }) => {
  const user = getAccount();

  const [showSchedule, setShowSchedule] = useState(false);
  const [isPending, setPending] = useState(false);
  const [isPending1, setPending1] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [fetchData, SetFetchData] = useState({});
  const [loanAmount, setLoanAmount] = useState(0);
  const [quantity, setQuantity] = useState("0");
  const [loanIndex, setLoanIndex] = useState(0);
  const [difference, SetDifference] = useState(0);
  const [tradeInfo, setTradeInfo] = useState({});
  const [maxFlashLoan, SetMaxFlashLoan] = useState(0);
  const [isActive, SetActive] = useState(0);
  const [planExpiry, setplanExpiry] = useState()
  const [planId, setPlanId] = useState()
  const [userPlanExpiry, setuserPlanExpiry] = useState();
  const [userInfo, setuserInfo] = useState({})


  const handleCloseSchedule = () => setShowSchedule(false);
  const handleShowSchedule = () => setShowSchedule(true);

  useEffect(() => {
    SetFetchData(data);
    const userInfo =
      sessionStorage.getItem("user") &&
      JSON.parse(sessionStorage.getItem("user"));
    let loanAmountIN = 0;
    if (
      data?.trade?.loanAmounts &&
      parseInt(data?.trade?.loanAmounts[0]) == 0
    ) {
      setLoanAmount(data?.trade?.loanAmounts[1]);
      setLoanIndex(1);
      loanAmountIN = data?.trade?.loanAmounts[1];
    } else if (data?.trade?.loanAmounts) {
      setLoanAmount(data?.trade?.loanAmounts[0]);
      setLoanIndex(0);
      loanAmountIN = data?.trade?.loanAmounts[0];
    }
    if (userInfo && userInfo != undefined) {
      console.log("userInfo?.plan : ", userInfo);
      setuserInfo(userInfo)
      // GetPlanInfo({ id: userInfo?.subscriptionPlans[0]?._id })
      //   .then((info) => {
      SetMaxFlashLoan(userInfo?.subscriptionPlans[0]?.flashLoanLimit);
      if (loanAmountIN > userInfo?.subscriptionPlans[0]?.flashLoanLimit) {
        setLoanAmount(userInfo?.subscriptionPlans[0]?.flashLoanLimit);
      }
      // })
      // .catch((e) => console.log("Error : ", e));
    }

    SetDifference(String(data?.difference).split(" ")[0]);
    setTradeInfo(data.trade);
  }, []);

  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
  var numbers = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;

  const ChangeLoan = (e) => {

    const userInfo =
      sessionStorage.getItem("user") &&
      JSON.parse(sessionStorage.getItem("user"));

    console.log("userInfo?.subscriptionPlans", userInfo?.subscriptionPlans);

    if (userInfo && userInfo?.subscriptionPlans.length != 0) {
      var loan = e.target.value;
      setQuantity(loan);
      if (isNumeric(loan)) {
        if (parseFloat(loan) > parseFloat(maxFlashLoan))
          return toast.error(`Max Flash loan for this plan is ${maxFlashLoan}`);
        const loans = toFixedNumber(parseInt(parseFloat(loan || 0) * 10 ** 18));
        console.log("ChangeLoan : ", loans);
        setLoanAmount(loans);
        let loanAmounts = [];
        loanAmounts[0] = loanIndex == 0 ? loans : "0";
        loanAmounts[1] = loanIndex == 1 ? loans : "0";
        setTradeValue("loanAmounts", loanAmounts);
        setTradeValue("amounts", loanAmounts);
        setTradeValue("_amount", loans);
      }
    }
    else {
      setQuantity(0)
      toast.error(`Buy A subscription Plan To Trade`);
    }

  };

  const ChangeDiff = (e) => {
    var diff = e.target.value || 0;
    SetDifference(diff);
    setFetchData("difference", diff);
  };

  const setTradeValue = (key, value) => {
    setTradeInfo((trade) => {
      trade[key] = value;
      return trade;
    });
  };

  const setFetchData = (key, value) => {
    SetFetchData((fetch) => {
      fetch[key] = value;
      return fetch;
    });
  };

  const addSchedules = async (trade) => {
    try {
      await UseSchedulePay(trade)
        .then(async (data) => {
          let trades = trade;
          trades = { ...trades, user: getAccount() };
          trades.trade = tradeInfo;
          delete trades["_id"];
          const result = await AddSchedule(trades);
          if ((result.status = "success")) {
            toast.success(result.message);
          } else {
            toast.error("Insufficient Gas Fee Error While Schelduling !");
          }
        })
        .catch((e) => {
          console.log(e);
          toast.error("Insufficient Gas Fee Error While Schelduling !");
        });
    } catch (e) {
      console.log("Error : ", e);
    }
  };



  const userPlanData = async () => {
    let userP = await userPlanDetail()
    setPlanId(userP.subscribeId)

    console.log("new Date(Number(userP.validTill) * 1000).getTime()", userP.subscribeId, new Date(Number(userP.validTill) * 1000).getTime());

    // if (userP.subscribeId != "") {
    //   setplanExpiry(new Date(Number(userP.validTill) * 1000).getTime())
    // }
  }


  const userPlanFromDB = async () => {
    try {
      let { status, message, data } = await getPlanData({
        userId: userInfo?._id,
      });
      console.log("getPlanData", data);

      if (status == true) {
        setuserPlanExpiry(Number(data.expiryTime) * 1000);
        setplanExpiry(Number(data.expiryTime) * 1000);

      }
      console.log(status, message, data, "status, message, data");
    } catch (err) {
      console.log(err);
    }
  };



  useEffect(() => {
    userPlanData()
    userPlanFromDB()
  }, [user, userInfo]);

  return (
    <>
      <Modal
        centered
        size="sm"
        show={show}
        onHide={(e) => { handleClose(); setQuantity(0) }}
        backdrop="static"
        keyboard={false}>
        <Modal.Body className="cmn__modal">
          <p className="text-end m-0 modal__closer" onClick={(e) => { handleClose(); setQuantity(0) }}>
            <i class="fa-solid fa-xmark" />
          </p>
          {/* <p className="m-0 hebrew_font ticketManage__question">Pair :</p> */}
          <h5 class="title_txt mb-0 text-white">Pair:</h5>
          <div className="d-flex justify-content-center mt-4 pt-2">
            <div className="dashboard__singleCard">
              <div className="d-flex justify-content-start align-items-center gap-5">
                <div className="opCard__topSecLeft">
                  <img
                    src={data?.token0?.logoURI}
                    className="img-fluid opCard__coinImg"
                    alt=""
                  />
                  <p className="m-0 herbrew_reg modal__coinName mt-4 text-center text-uppercase">
                    {data?.token0?.symbol}
                  </p>
                </div>
                <p className="m-0 dashboard__transactAct">
                  <i class="fa-solid fa-plus" />
                </p>
                <div className="opCard__topSecLeft">
                  <img
                    src={data?.token1?.logoURI}
                    className="img-fluid opCard__coinImg"
                    alt=""
                  />
                  <p className="m-0 herbrew_reg modal__coinName mt-4 text-center text-uppercase">
                    {data?.token1?.symbol}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="modal__singleInpFlex d-flex justify-content-start align-items-center gap-3 my-4">
            <p className="m-0 hebrew_font ticketManage__question cmnModal_inpLabel">
              Borrow Amount :
            </p>
            <div className="position-relative flex-grow-1">
              <input
                onChange={(e) => ChangeLoan(e)}
                placeholder={` MAX : ${toFixedNumber(
                  parseFloat(loanAmount) / 10 ** 18
                )}`}
                type="number"
                min={0}
                value={quantity && quantity}
                className="ticketManage__input hebrew_font w-100 rounded-1"
              />
            </div>
          </div>

          <div className="modal__singleInpFlex d-flex justify-content-start align-items-center gap-3 mb-4">
            <p className="m-0 hebrew_font ticketManage__question cmnModal_inpLabel">
              Estimate Profit :
            </p>
            <div className="position-relative flex-grow-1">
              <p className="modal__inputAbs m-0 hebrew_font">%</p>
              <input
                type="text"
                onChange={(e) => ChangeDiff(e)}
                value={difference && difference}
                className="ticketManage__input hebrew_font w-100 rounded-1"
              />
            </div>
          </div>

          {/* <div className='modal__singleInpFlex'>
        <p className='m-0 hebrew_font ticketManage__question'>Profit expected :</p>
        <div className='position-relative'>
        <p className='modal__inputAbsDollar m-0 hebrew_font'>{data?.gains && String(data?.gains).split(" ")[1]}</p>
        <input type='text' value={data?.gains && String(data?.gains).split(" ")[0]} className='ticketManage__input hebrew_font w-100 rounded-1 mt-2' />
        </div>
        </div> */}

          <div className="cmnModal__dualBtns d-flex justify-content-between mt-4">
            {CURRENT_CHAIN_ID() == 56 ? (
              <button
                className="primary_grad_btn rounded-5 primary_gradBtnWidth hebrew_strong"
                onClick={async () => {
                  setPending(true);
                  if (planId != "") {

                    console.log("planExpiryplanExpiry", planExpiry, Date.now());

                    if (planExpiry > Date.now()) {
                      if (quantity != 0) {
                        UseTriggerArbitrage(tradeInfo)
                          .then(async (datas) => {
                            let loanAmountIN = 0;
                            if (
                              tradeInfo?.loanAmounts &&
                              parseInt(tradeInfo?.loanAmounts[0]) == 0
                            ) {
                              loanAmountIN = tradeInfo?.loanAmounts[1];
                            } else if (tradeInfo?.loanAmounts) {
                              loanAmountIN = tradeInfo?.loanAmounts[0];
                            }
                            let diff = fetchData.difference.split("%");
                            loanAmountIN = loanAmountIN / 10 ** 18;
                            let prof = (parseFloat(diff[0]) * loanAmountIN) / 100;
                            prof = prof + loanAmountIN;
                            let feeAmount = (0.09 * prof) / 100;
                            prof = prof - feeAmount;
                            let { status, message, result } = await AddTransaction({
                              transactionHash: datas.transactionHash,
                              address: getAccount(),
                              token0: fetchData.token0,
                              token1: fetchData.token1,
                              symbol: fetchData.symbol,
                              prices: fetchData.prices,
                              difference: fetchData.difference,
                              gains: fetchData.gains,
                              trade: tradeInfo,
                              chainId: fetchData.chainId,
                              amountIn: loanAmountIN,
                              profit: prof,
                            });
                            setSuccess(true);
                            setMessage(`Trade Success :  ${datas.transactionHash}`);
                            toast.success(`Trade Success :  ${datas.transactionHash}`);
                            setTimeout(() => setMessage(""), 30000);
                            setPending(false);
                          })
                          .catch((e) => {
                            setSuccess(false);
                            console.log(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment : ${e}`);
                            toast.error(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`);
                            setMessage(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`);
                            setPending(false);
                            setTimeout(() => setMessage(""), 30000);
                          });
                      } else {
                        setSuccess(false);
                        toast.error(`Borrow Should Not 0`);
                        setMessage(`Borrow Should Not 0`);
                        setPending(false);
                        setTimeout(() => setMessage(""), 30000);
                      }
                    }

                    else {
                      setSuccess(false);
                      toast.error(`Your Plan Is Expired`);
                      setMessage(`Your Plan Is Expired`);
                      setPending(false);
                      setTimeout(() => setMessage(""), 30000);
                    }
                  }
                  else {
                    setSuccess(false);
                    toast.error(`Buy A subscription Plan To Trade!`);
                    setMessage(`Buy A subscription Plan To Trade!`);
                    setPending(false);
                    setTimeout(() => setMessage(""), 30000);

                  }

                }}>
                {isPending ? "Trading..." : "Confirm"}
              </button>
            ) : (
              <button
                className="primary_grad_btn rounded-5 primary_gradBtnWidth hebrew_strong"
                onClick={async () => {
                  setPending(true);
                  if (planId != "") {
                    if (planExpiry > Date.now()) {

                      console.log("planExpiryplanExpiry", planExpiry, Date.now());
                      if (quantity != 0) {
                        UseTriggerArbitragePoly(tradeInfo)
                          .then(async (datas) => {
                            let loanAmountIN = 0;
                            if (
                              tradeInfo?.loanAmounts &&
                              parseInt(tradeInfo?.loanAmounts[0]) == 0
                            ) {
                              loanAmountIN = tradeInfo?.loanAmounts[1];
                            } else if (tradeInfo?.loanAmounts) {
                              loanAmountIN = tradeInfo?.loanAmounts[0];
                            }
                            let diff = fetchData.difference.split("%");
                            loanAmountIN = loanAmountIN / 10 ** 18;
                            let prof = (parseFloat(diff[0]) * loanAmountIN) / 100;
                            prof = prof + loanAmountIN;
                            let feeAmount = (0.05 * prof) / 100;
                            prof = prof - feeAmount;
                            let { status, message, result } = await AddTransaction({
                              transactionHash: datas.transactionHash,
                              address: getAccount(),
                              token0: fetchData.token0,
                              token1: fetchData.token1,
                              symbol: fetchData.symbol,
                              prices: fetchData.prices,
                              difference: fetchData.difference,
                              gains: fetchData.gains,
                              trade: tradeInfo,
                              chainId: fetchData.chainId,
                              amountIn: loanAmountIN,
                              profit: prof,
                            });
                            setSuccess(true);
                            setMessage(`Trade Success :  ${datas.transactionHash}`);
                            toast.success(`Trade Success :  ${datas.transactionHash}`);
                            setTimeout(() => setMessage(""), 30000);
                            setPending(false);
                            handleClose();
                          }).catch((e) => {
                            setSuccess(false);
                            console.log(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment : ${e}`);
                            toast.error(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`);
                            setMessage(`Opportunity is missed ! : The Return Amount is Insufficient For Loan Repayment`);
                            setPending(false);
                            setTimeout(() => setMessage(""), 30000);
                          });

                      } else {
                        setSuccess(false);
                        toast.error(`Borrow Should Not 0`);
                        setMessage(`Borrow Should Not 0`);
                        setPending(false);
                        setTimeout(() => setMessage(""), 30000);
                      }
                    }
                    else {
                      setSuccess(false);
                      toast.error(`2Your Plan Is Expired`);
                      setMessage(`Your Plan Is Expired`);
                      setPending(false);
                      setTimeout(() => setMessage(""), 30000);
                    }
                  }
                  else {
                    setSuccess(false);
                    toast.error(`Buy A subscription Plan To Trade!`);
                    setMessage(`Buy A subscription Plan To Trade!`);
                    setPending(false);

                    setTimeout(() => setMessage(""), 30000);

                  }
                }}>
                {isPending ? "Trading..." : "Confirm"}
              </button>
            )}
            <button
              className="secondary_btn cmnModal_secondaryBtn rounded-5 primary_gradBtnWidth hebrew_strong"
              onClick={async () => {
                setPending1(true);
                await addSchedules(fetchData);
                setPending1(false);
                handleClose();
              }}
              data={isPending1 ? "Scheduling..." : "Schedule"}
            // onClick={() => {handleShowSchedule();handleClose()}}
            >
              {" "}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* schedule Modal */}
      <ScheduleModal
        show={showSchedule}
        handleClose={handleCloseSchedule}
        handleShow={handleShowSchedule}
      />
      {/* end of schedule Modal */}
    </>
  );
};

export default PairModal;
